import { UnitTypes } from '../../../interfaces/Unit';
import Translation from '../../../../Shared/components/Translation';
import { ZdsButton } from '@zig-design-system/ui-components-react';
import React, { useContext } from 'react';
import { RootContext } from '../../../../Context/RootContext';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
const getGenericLinkUrl = (unit, pluginContext) => {
    let linkUrl;
    const params = new URLSearchParams({
        vhe: unit.vhe || unit.name,
        streetName: unit.street,
        houseNumber: unit.houseNumber,
        houseNumberAddition: unit.houseNumberAddition,
        city: unit.city,
    });
    if (unit.isAdvertised) {
        switch (unit.type) {
            case UnitTypes.buy:
                linkUrl = new URL(pluginContext.reactionPageBuy);
                break;
            case UnitTypes.rent:
                linkUrl =
                    unit.isPrivateSector && pluginContext.reactionPagePrivateSector
                        ? new URL(pluginContext.reactionPagePrivateSector)
                        : new URL(pluginContext.reactionPageRent);
                break;
            case UnitTypes.parking:
                linkUrl = new URL(pluginContext.reactionPageParking);
                break;
            case UnitTypes.storage:
                linkUrl = new URL(pluginContext.reactionPageStorage);
                break;
            case UnitTypes.companySpace:
                linkUrl = new URL(pluginContext.reactionPageCompanySpace);
                break;
            default:
                throw new Error(`UnitType ${unit.type} has no mapping to the correct reaction page.`);
        }
    }
    else {
        linkUrl = new URL(pluginContext.reactionPageProperty);
    }
    linkUrl.search = params.toString();
    return linkUrl;
};
const Reaction = ({ unit }) => {
    const showGenericReactionPageButton = () => {
        if (unit.isAdvertised) {
            return ((unit.type === UnitTypes.buy && pluginContext.reactionPageBuy) ||
                (unit.type === UnitTypes.rent && pluginContext.reactionPageRent) ||
                (unit.type === UnitTypes.rent && unit.isPrivateSector && pluginContext.reactionPagePrivateSector) ||
                (unit.type === UnitTypes.parking && pluginContext.reactionPageParking) ||
                (unit.type === UnitTypes.storage && pluginContext.reactionPageStorage) ||
                (unit.type === UnitTypes.companySpace && pluginContext.reactionPageCompanySpace));
        }
        else {
            return !!pluginContext.reactionPageProperty;
        }
    };
    if (!unit.responseDeadline && !showGenericReactionPageButton && !unit.externalDetailUrl) {
        return null;
    }
    const pluginContext = useContext(RootContext).pluginContext;
    const renderReactionButton = (type) => {
        let linkUrl = null;
        if (type === 'generic') {
            try {
                linkUrl = getGenericLinkUrl(unit, pluginContext);
            }
            catch (e) {
                return (React.createElement(Alert, { type: AlertType.error, message: React.createElement(Translation, { item: "tx_zigrealestate.error.urlNotValid", asString: true }) }));
            }
        }
        if (type === 'external') {
            try {
                linkUrl = new URL(unit.externalDetailUrl);
            }
            catch (e) {
                return (React.createElement(Alert, { type: AlertType.error, message: React.createElement(Translation, { item: "tx_zigrealestate.error.urlNotValid", asString: true }) }));
            }
        }
        if (linkUrl) {
            return (React.createElement(ZdsButton, { size: "lg", link: linkUrl.href, linkTarget: linkUrl.hostname !== window.location.host ? '_blank' : '_self' },
                React.createElement(Translation, { item: "tx_zigrealestate.detail.respond" })));
        }
    };
    const render = () => {
        const itemsToRender = [];
        if (unit.responseDeadline && new Date(unit.responseDeadline) < new Date()) {
            return null;
        }
        if (unit.responseDeadline) {
            itemsToRender.push(React.createElement("div", null,
                React.createElement(Translation, { item: "tx_zigrealestate.reactBefore" }),
                ' ',
                new Date(unit.responseDeadline).toLocaleDateString('nl-NL', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                })));
        }
        if (unit.externalDetailUrl) {
            itemsToRender.push(renderReactionButton('external'));
        }
        else if (showGenericReactionPageButton()) {
            itemsToRender.push(renderReactionButton('generic'));
        }
        if (itemsToRender.length > 0) {
            return (React.createElement("div", { className: "md:zds-col-6 zds-flex zds-color-grey md:zds-items-end" },
                React.createElement("div", { className: "zds-flex zds-flex-1 zds-flex-col zds-margin-top-6\n                        md:zds-flex-row md:zds-margin-top-0 zds-gap-4 md:zds-items-center md:zds-justify-content-end" }, itemsToRender.map((item, index) => (React.createElement(React.Fragment, { key: index }, item))))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    return render();
};
export default Reaction;
